import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  HomeIcon,
  CalendarDaysIcon,
  CurrencyDollarIcon,
  UsersIcon,
  UserIcon,
  CreditCardIcon,
  ClockIcon,
  ChartBarIcon,
  CogIcon,
  BellIcon,
  ArrowRightOnRectangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import adminAPI from "../../utils/api";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const [notificationCount, setNotificationCount] = useState(0);

  // Fetch notification count
  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const data = await adminAPI.getNotificationCount();
        setNotificationCount(data.unread_count || 0);
      } catch (error) {
        console.error('Error fetching notification count:', error);
      }
    };

    fetchNotificationCount();

    // Refresh count every 30 seconds
    const interval = setInterval(fetchNotificationCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const navigation = [
    { name: "Tableau de bord", href: "/dashboard", icon: HomeIcon },
    { name: "Réservations", href: "/bookings", icon: CalendarDaysIcon },
    { name: "Commandes", href: "/orders", icon: CurrencyDollarIcon },
    { name: "Clients", href: "/clients", icon: UsersIcon },
    { name: "Coachs", href: "/coaches", icon: UserIcon },
    { name: "Services", href: "/services", icon: CreditCardIcon },
    { name: "Planning", href: "/schedule", icon: ClockIcon },
    { name: "Notifications", href: "/notifications", icon: BellIcon },
    { name: "Analyses", href: "/analytics", icon: ChartBarIcon },
    // { name: "Paramètres", href: "/settings", icon: CogIcon },
  ];

  const isActive = (path) => {
    if (path === "/dashboard" && location.pathname === "/") return true;
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-sm border-r border-gray-200 flex flex-col transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:static lg:inset-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
      {/* Logo */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <img
            className="h-16 w-auto text-white bg-primary-600 rounded-lg flex items-center justify-center shadow-lg "
            src="/assets/icons/nazai-studio-logo.png"
            alt="Nazaï Studio"
          />

          {/* Close button for mobile */}
          <button
            onClick={() => setIsOpen(false)}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`sidebar-item ${isActive(item.href) ? "active" : ""}`}
            >
              <Icon className="h-5 w-5 mr-3" />
              <span className="font-medium">{item.name}</span>
              {item.href === "/notifications" && notificationCount > 0 && (
                <span className="ml-auto bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {notificationCount > 9 ? '9+' : notificationCount}
                </span>
              )}
            </Link>
          );
        })}
      </nav>

      {/* User Section */}
      <div className="p-4 border-t border-gray-200">
        

        <button className="w-full flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200">
          <ArrowRightOnRectangleIcon className="h-4 w-4 mr-2" />
          <span className="text-sm">Déconnexion</span>
        </button>
      </div>
    </div>
    </>
  );
};

export default Sidebar;
